/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Emptytitle2Inputs */

const en_notificationcenter_emptytitle2 = /** @type {(inputs: Notificationcenter_Emptytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're all caught up`)
};

/**
* | output |
* | --- |
* | "You're all caught up" |
*
* @param {Notificationcenter_Emptytitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_emptytitle2 = /** @type {((inputs?: Notificationcenter_Emptytitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Emptytitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_emptytitle2(inputs)
});
export { notificationcenter_emptytitle2 as "notificationCenter_emptyTitle" }